import * as React from 'react';
import styled from 'styled-components';
import { Heading } from '$ui/Flo/Heading';
import { Icon } from '$ui/Flo/Icon';
import { usePageTitle } from '@/utils/hooks';
import { Container } from '@/views/Elements';

export const IncomingPatients = () => {
    usePageTitle('Incoming Patients');

    return (
        <Container>
            <Heading level="h3" align="left" vSpace={2}>
                Incoming Patients
            </Heading>

            <Empty>
                <Icon icon="UserCheck" size={8} opacity={1} hue="green" />
                <Heading level="h3" profile="body">
                    There are no incoming patients from Dentally
                </Heading>
            </Empty>
        </Container>
    );
};

const Empty = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 5%;
    height: 25vh;
`;
